import { useState, useEffect } from 'react';

// Devuelve true cuando la media query coincide. Se actualiza al redimensionar
// o rotar el dispositivo, por lo que sirve para adaptar la vista a móvil/escritorio.
export function useMediaQuery(query) {
  const getMatch = () =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    // addEventListener es el método moderno; addListener es el respaldo para
    // navegadores antiguos.
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else mql.removeListener(handler);
    };
  }, [query]);

  return matches;
}

// Atajo: true en pantallas de celular (<= 768px de ancho).
export function useIsMobile() {
  return useMediaQuery('(max-width: 768px)');
}

export default useMediaQuery;
